import "@fontsource/oswald";
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const DriverBenefits = () => {
    return (
        <div className="bg-gray-100 text-gray-900 min-h-screen flex flex-col">
            <HeaderBlue />
            {/* Hero Section */}
            <section className="w-full py-60 relative bg-cover bg-top px-3"
                style={{
                    backgroundImage: "url('./assets/HAPPY DRIVER.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl font-medium font-oswald drop-shadow-lg pb-5">DRIVER BENEFITS</h2>
                    <p className="text-white text-xl font-semibold font-oswald mt-2">
                        Join us to unlock opportunities and resources <br />
                        designed to advance your trucking career.
                    </p>
                </div>
            </section>

            {/* Main Content */}
            <main className="max-w-6xl mx-auto mt-10 px-5 w-full">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
                    {[
                        {
                            icon: 'fa-briefcase',
                            title: 'Job Opportunities',
                            desc: 'Access a wide range of job listings from top trucking companies, tailored to your experience and preferences.',
                        },
                        {
                            icon: 'fa-map-marked-alt',
                            title: 'Flexible Routes',
                            desc: 'Find jobs that match your preferred routes, whether local, regional, or over-the-road, to suit your lifestyle.',
                        },
                        {
                            icon: 'fa-dollar-sign',
                            title: 'Competitive Pay',
                            desc: 'Compare salary details across job listings to secure the best-paying opportunities in the industry.',
                        },
                        {
                            icon: 'fa-user-check',
                            title: 'Profile Visibility',
                            desc: 'Showcase your skills and experience to carriers with a verified driver profile, increasing your chances of being hired.',
                        },
                    ].map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 flex flex-col hover:shadow-xl hover:-translate-y-1 hover:scale-[1.03] transition duration-300"
                        >
                            <i className={`fas ${item.icon} text-4xl text-[#3c9bf9] mb-4`}></i>
                            <div className="text-xl font-bold text-black mb-3">{item.title}</div>
                            <div className="text-gray-900 text-base leading-relaxed">{item.desc}</div>
                        </div>
                    ))}
                </div>
            </main>
            <FooterBlue />
        </div>
    );
};

export default DriverBenefits;
